module.exports = __webpack_public_path__ + "img/benefit_card_image_9.7e6f3932.png";